import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { VidLogo } from "src/components/Icons";
import { Nav } from "src/components";
import { isEmbedded } from "src/helpers/utils/isEmbedded";
import { highContrastThemeAtom } from "src/shame/shame-atoms";

const Wrapper = styled.div`
	height: 100%;
	padding-bottom: 50px;
`;

const MainPageContainer = styled.div<{ $highContrast?: boolean; $navPadding: boolean }>`
	align-items: flex-start;
	background-color: #fff;
	display: flex;
	height: 100%;
	justify-content: center;
	padding-top: ${(props) => (props.$navPadding ? 94 : 0)}px;
  background-attachment: fixed;
  background-image: ${({ $highContrast }) => ($highContrast ? "none" : "url(/static/img/header-fade.png)")};
  background-position: 17.5% ${(props) => (props.$navPadding ? 94 : 0)}px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  @media screen and (max-width: 750px) {
    background-size: auto 90%;
    background-position: 40% ${(props) => (props.$navPadding ? 94 : 0)}px;
  }
`;

interface ComponentProps {
	children: React.ReactNode;
	showUserControls?: boolean;
}

/**
 * Main Page Layout component
 * We can pass childrent to this component
 * @returns React Node
 */
export function NoSideBarLayout({ children, showUserControls }: Readonly<ComponentProps>) {
	const [showNav, setShowNav] = useState(true);
	const isHighContrast = useAtomValue(highContrastThemeAtom);

	useEffect(() => {
		setShowNav(!isEmbedded());
	}, []);

	return (
		<Wrapper id="page-wrapper">
			{showNav ? (
				<Nav
					navLogoAltText={"vID Logo"}
					{...(isHighContrast && { navLogoComponent: <VidLogo highContrast /> })}
					navLogoImageSource={"/static/img/vid_mark.svg"}
					showUserControls={showUserControls}
				/>
			) : null}
			<MainPageContainer $highContrast={isHighContrast} id="content-wrapper" $navPadding={showNav}>
				{children}
			</MainPageContainer>
		</Wrapper>
	);
}
